export const useLimits = (): Limits => {
	return window.global.central.limits();
};
